import React from 'react';
import useViewDocument from './useViewDocument';

const ViewDocumentContext = React.createContext<ReturnType<typeof useViewDocument>>({});

export default ViewDocumentContext;
